import { checkRole, findServiceArea, getAddressDetails, isOneHourViolation, spaceTypeList } from './../../../utils/utils.common';
import { parseAddress } from 'us-address-parser';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert, sweetAlertWithTwoCheckboxes } from 'src/app/utils/swal';
import { Router, ActivatedRoute } from '@angular/router';
import { getBrokersList, getstandingOrderDays } from '../../../utils/utils.common';
import { generateHmacSignature } from 'src/app/utils/crypto-utils';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { KeyValue } from '@angular/common';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ToastrService } from 'ngx-toastr';
import { TripPurposesService } from '../../trip-purposes/service/trip-purposes.service';
import { MemberService } from '../../members/member-service/member.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { ModifierCodesService } from '../../modifier-codes/modifier-codes-service/modifier-codes.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { PrimaryDiagnosisService } from '../../primary-diagnosis/primary-diagnosis-service/primary-diagnosis.service';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { PayorService } from 'src/app/service/payor/payor.service';

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css']
})
export class NewTripComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @Input('editId') editId;
  @Input() trip?;
  @Input() source?;
  @Output() onUpdate = new EventEmitter<string>();
  @Output() onCreate = new EventEmitter<string>();

  version = '2';
  isNewTripPage = false;

  newTripForm: FormGroup;
  addonsServicesForm: FormGroup;
  timeZone = "America/New_York";
  todayDate = moment().tz(this.timeZone);
  user;
  memberList = [];
  fundingSourceList = [];
  tripPurposeList = [];
  modifierList = [];
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  serviceAreaList = [];
  primaryDiagnoseList = [];
  addonsList = [];
  filteredAddonsList = [];
  driverList = [];
  isAllowRates = false;
  tripId;
  submitted = false;
  addMemberModalObj;
  addressPickerObj;
  assistList;
  selectedAssist= [];
  suggestedPickupTime;
  isCalculating = false;
  isEditDataLoaded = false;
  is1HourException = false;
  minDate = moment().tz(this.timeZone).startOf('day');
  isEnableExpectedAppointment = false;
  isEnabledOneHourException = true;
  tripDetails: any;
  possibilityObj;
  isPossibility = false;
  payorList:any;
  selectedMember:any;
  isCheckingAvailability = false;
  availabilityDateRange: any = null;
  availabilityStats: any = null;
  dateMultiDays: any = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private equipmentService: EquipmentService,
    private proTipsService: ProTipsServiceService,
    private driverService: DriversService,
    private toastr: ToastrService,
    private tripPurposesService: TripPurposesService,
    private memberService: MemberService,
    private corporateService: CorporateService,
    private modifierCodesService: ModifierCodesService,
    private levelOfServiceService: LevelOfServiceService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private serviceArea: ServiceAreasService,
    private assistService : AssistService,
    private payorService: PayorService
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
      this.tripId = this.activatedRoute.snapshot.url[1].path;
    }

    this.isNewTripPage = !!this.activatedRoute.snapshot.data['newTripPage'];


    this.newTripForm = this.fb.group({
      company: ['', Validators.required],
      eligibilityStatus:[''],
      rawId: [''],
      tripId: [''],
      isMedical: [false], // will remove later
      companyType: [''], // will remove later
      jobType: ['cooperate', Validators.required], // will remove later

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, Validators.required],
      jobDestinationLongitude: [0, Validators.required],
      zipCodeDest: [''],
      cityDest: [''],
      stateDest: [''],
      doStreet: [''],

      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: [0, Validators.required],
      jobOriginLongitude: [0, Validators.required],
      zipCodeOrg: [''],
      cityOrg: [''],
      stateOrg: [''],
      puStreet: [''],

      client: ['', Validators.required],
      los: ['', Validators.required],
      losDetails: [{}, Validators.required],
      spaceType: ['', Validators.required],
      spaceTypeDetails: [{}, Validators.required],

      priorityClient: this.fb.group({
        displayName: ['', Validators.required],
        contactNumber: ['', Validators.required],
        cellPhone: [''],
        clientId: [''],
        email: [''],
        preDob: [''],
        dob: [''],
        weight: [''],
        gender: ['']
      }),

      originAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),

      cooperate: ['', Validators.required],
      payorId: [''],
      cooperateDetails: [{}],

      preScheduleTime: ["", Validators.required],
      preAppointmentTime: ["", Validators.required],
      appointmentTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],
      preActualAppointmentTime: [""],
      actualAppointmentTime: [""],
      milage: [null],
      tripLegs: this.fb.array([]),
      addonServices: this.fb.array([]),
      multidates: this.fb.array([]),
      noOfEscorts: [''],
      tripReason: [[]],
      ipa: [''],
      primaryDiagnosis: [''],
      companyNote: [''],
      dispatchNoteTwo: [''],
      attachment: [''],

      preRecurringEndDate: [null],
      recurringEndDate: [''],
      isStandingOrder: [false],
      isRecurring: [false],
      recurringDays: this.fb.array([]),
      status: [''],
      jobStatus: [''],
      driver: [null],
      events: [[]],
      serviceArea: ['', Validators.required],
      serviceAreaDest: ['', Validators.required],
      // Local Variable
      estimateFare: [{ value: '', disabled: true }],
      isVipTrip: [false],
      isConfirmedTrip: [false],
      authorizationNumber: [''],
      isWillCall: [false],

    isUpdateSameDayLegs: [{ value: false, disabled: true }],
    isUpdateFutureLegs: [{ value: false, disabled: true }],
      appointmentDirection: ['']


    });
    this.addStandingDays();


    if (this.editId) {
      this.tripId = this.editId;
    }

    this.makeCompulsoryCalls();
    this.formControlsListeners();
  }

  formControlsListeners() {
    this.newTripForm.controls['jobOriginAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });
    this.newTripForm.controls['jobDestinationAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });
    if (this.newTripForm.controls['authorizationNumber']) {
      this.newTripForm.controls['authorizationNumber']
        .valueChanges
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(() => {
          this.resetAvailabilityStats();
        });
    }
    this.newTripForm.valueChanges
      .subscribe(formValue => {
        const requiredFields = [
          'jobOriginLatitude',
          'jobOriginLongitude',
          'jobDestinationLatitude',
          'jobDestinationLongitude',
          'jobDestinationAddress',
          'jobOriginAddress',
          'cooperate',
          'spaceType',
          'scheduleTime',
          // 'milage',
          'appointmentTime',
          // 'serviceArea'
        ];
        const isValid = requiredFields.every(
          field => {

            return formValue[field] !== null && formValue[field] !== ''
          }
        );
        this.possibilityObj = isValid ? formValue : null;
      });
  }

  setFormFromInputTrip(data) {
    const preData = JSON.parse(JSON.stringify(data));

    this.newTripForm.patchValue({
      ...preData,
      preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
      preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone)
    });

    if (data.cooperate) {
      this.getAddonsList(data.cooperate);
      this.getMemberList(data.cooperate);
    }
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2]) => {

        if (res1) {
          this.levelOfServiceList = res1;
        }
        if (res2) {
          this.spaceTypeMainList = res2;
        }

        this.getTripPurposeList();
        this.getFundingSourceList();
        this.getModifierList();
        this.getPrimaryDiagnoseList();
        // this.getAddonsList();
        this.getAssisData()
        this.getUser();
        this.getServiceAreaList();
        this.getPayorList();

      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment().tz(this.timeZone);
          this.minDate = this.tripId ? null : moment().tz(this.timeZone).startOf('day');
          this.newTripForm.patchValue({
            company: this.user._id,

            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),

            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
            preActualAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            actualAppointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
          });

          if (!this.isEnableExpectedAppointment) {
            this.clearExpectedAppointmentValidation();
          }

          this.getDriverList();

          if (this.tripId) {
            this.getTripDetails();
          }

          if (this.trip) {
            this.setFormFromInputTrip(this.trip);
          }

          this.isAllowRates = checkRole(this.user);
          if (this.user.hasOwnProperty('hideOneHourException') && this.user.hideOneHourException) {
            this.isEnabledOneHourException = false;
          }
        }
      });
  }

  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripDetails = data;
          const preData = JSON.parse(JSON.stringify(data));
          // remove standing order
          delete preData.recurringDays;
          delete preData.addonServices;

          const originParsed = preData.jobOriginAddress ? parseAddress(preData.jobOriginAddress) : null;
          const destinationParsed = preData.jobDestinationAddress ? parseAddress(preData.jobDestinationAddress) : null;

          this.newTripForm.patchValue({
            ...preData,
            preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
            preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone),
            preActualAppointmentTime: moment(preData.actualAppointmentTime).tz(this.timeZone),
            preRecurringEndDate: preData.recurringEndDate ? moment(preData.recurringEndDate).tz(this.timeZone) : null,
            priorityClient: {
              ...preData.priorityClient,
              preDob: preData.priorityClient && preData.priorityClient.dob ? moment(preData.priorityClient.dob).tz(this.timeZone) : '',
              dob: preData.priorityClient.dob
          },
            payorId: preData.payorId ? preData.payorId : '',
            cityOrg: originParsed ? originParsed.city : '',
            stateOrg: originParsed ? originParsed.state : '',
            puStreet: originParsed ? originParsed.street : '',
            cityDest: destinationParsed ? destinationParsed.city : '',
            stateDest: destinationParsed ? destinationParsed.state : '',
            doStreet: destinationParsed ? destinationParsed.street : ''
          });
          if (this.isEnabledOneHourException) {
            this.is1HourException = preData.isAnHourException;
          }

          this.onSelectLOS(data.los);

          if (data.cooperate) {
            this.getAddonsList(data.cooperate);
            this.getMemberList(data.cooperate);
          }

          if (data.addonServices) {
            this.addAddonsItem(data.addonServices)
          }

          if (data.status === "standing") {
            this.addStandingDays(data.recurringDays);
          }

          this.selectedAssist = data.attendees;

          this.isEnableExpectedAppointment = data.isEnableExpectedAppointment;

          if (!this.isEnableExpectedAppointment) {
            this.clearExpectedAppointmentValidation();
          }

          setTimeout(() => {
            this.isEditDataLoaded = true;
          }, 3000);
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getMemberList(fundingSourceId) {
    const queryParam = {
      accountStatus: 'active',
      cooperate: fundingSourceId
    }
    this.memberService
      .getMembers(queryParam)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.memberList = data;
          if (this.tripId) {
            this.selectedMember = this.memberList.find((member) => member._id === this.tripDetails.client);
            this.newTripForm.patchValue({
              eligibilityStatus: this.selectedMember && this.selectedMember.eligibility ? this.selectedMember.eligibility.status : ''
            });
          }
        }
      });
  }

  getTripPurposeList() {
    this.tripPurposesService
      .getTripPurposesList('active')
      .subscribe(data => {
        if (data) {
          this.tripPurposeList = data;
        }
      });
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSourceList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getModifierList() {
    this.modifierCodesService
      .getModifierCodes()
      .subscribe(data => {
        if (data) {
          this.modifierList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getPrimaryDiagnoseList() {
    this.primaryDiagnosisService
      .getPrimaryDiagnosis()
      .subscribe(data => {
        if (data) {
          this.primaryDiagnoseList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getAddonsList(fundingSourceId) {
    //add params to send the cooperate key in the equipment api
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    this.equipmentService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = data;
          this.onSelectSpaceType();

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  get form() {
    return this.newTripForm.controls;
  }

  get isCheckAvailabilityReady(): boolean {
    const hasMember = !!(this.selectedMember && this.selectedMember.clientId);
    const authNumber = this.newTripForm && this.newTripForm.get('authorizationNumber') ?
      this.newTripForm.get('authorizationNumber').value : null;
    const hasAuthNumber = !!(authNumber && (authNumber + '').trim().length > 0);
    const cooperateValue = this.newTripForm && this.newTripForm.get('cooperate') ?
      this.newTripForm.get('cooperate').value : null;
    const hasFundingSource = !!(cooperateValue && (cooperateValue + '').trim().length > 0);

    return hasMember && hasAuthNumber && hasFundingSource;
  }

  resetAvailabilityStats() {
    this.availabilityStats = null;
    this.availabilityDateRange = null;
  }

  async onAvailabilityDateRangeChange(event: any) {
    if (!event || !Array.isArray(event) || !event[0] || !event[1]) {
      return;
    }

    if (!this.isCheckAvailabilityReady || this.isCheckingAvailability) {
      return;
    }

    const startDate = moment(event[0]).tz(this.timeZone).startOf('day').toISOString();
    const endDate = moment(event[1]).tz(this.timeZone).endOf('day').toISOString();
    const authNumber = this.newTripForm && this.newTripForm.get('authorizationNumber') ?
      (this.newTripForm.get('authorizationNumber').value + '').trim() : '';
    const cooperateId = this.newTripForm && this.newTripForm.get('cooperate') ?
      this.newTripForm.get('cooperate').value : '';
    const mrn = this.selectedMember && this.selectedMember.clientId ? this.selectedMember.clientId : '';

    const payload = {
      mrn: mrn,
      authorizationNumber: authNumber,
      startDate: startDate,
      endDate: endDate
    };

    this.isCheckingAvailability = true;

    try {
      const jsonString = JSON.stringify(payload);
      const signature = await generateHmacSignature(jsonString, 'M3gSjvFv33XtzlhH');

      this.memberService.checkAvailability(payload, cooperateId, signature)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (res: any) => {
            this.isCheckingAvailability = false;
            if (res && res.total !== undefined) {
              this.availabilityStats = res;
            } else if (res && res.message) {
              this.resetAvailabilityStats();
              sweetAlert('Availability', res.message, 'info', 'OK');
            }
          },
          (err: any) => {
            this.isCheckingAvailability = false;
            this.resetAvailabilityStats();
            const errorMsg = err && err.message ? err.message : (typeof err === 'string' ? err : 'Failed to check availability.');
            sweetAlert('Error', errorMsg, 'error', 'OK');
          }
        );
    } catch (e) {
      this.isCheckingAvailability = false;
      this.resetAvailabilityStats();
      sweetAlert('Error', 'Failed to generate HMAC signature.', 'error', 'OK');
    }
  }

  get legForm() {
    return this.newTripForm.get('tripLegs') as FormArray;
  }

  addLegItem() {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    let preValues;
    if (items.length === 0) {
      preValues = this.newTripForm.value
    } else {
      preValues = items.at(items.length - 1).value;
    }

    let hour = items.length === 0 ? 1 : 2;
    // if (!items.invalid) {
    items.push(
      this.fb.group({
        jobDestinationAddress: [preValues.jobOriginAddress, Validators.required],
        jobDestinationLatitude: [preValues.jobOriginLatitude, Validators.required],
        jobDestinationLongitude: [preValues.jobOriginLongitude, Validators.required],
        zipCodeDest: [preValues.zipCodeOrg],
        cityDest: [preValues.cityOrg],
        stateDest: [preValues.stateOrg],
        doStreet: [preValues.puStreet || ''],
        serviceAreaDest: [preValues.serviceArea],

        jobOriginAddress: [preValues.jobDestinationAddress, Validators.required],
        jobOriginLatitude: [preValues.jobDestinationLatitude, Validators.required],
        jobOriginLongitude: [preValues.jobDestinationLongitude, Validators.required],
        zipCodeOrg: [preValues.zipCodeDest],
        cityOrg: [preValues.cityDest],
        stateOrg: [preValues.stateDest],
        puStreet: [preValues.doStreet || ''],
        serviceArea: [preValues.serviceAreaDest],

        preScheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        scheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        preAppointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        appointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        companyNote: [''],
        isWillCall: [false],

        originAddressAdditional: this.fb.group({
          modifier: [preValues.destinationAddressAdditional.modifier],
          modifierTwo: [preValues.destinationAddressAdditional.modifierTwo],
          floor: [preValues.destinationAddressAdditional.floor],
          room: [preValues.destinationAddressAdditional.room],
          aptOrSuite: [preValues.destinationAddressAdditional.aptOrSuite],
          place: [preValues.destinationAddressAdditional.place],
          phone: [preValues.destinationAddressAdditional.phone]
        }),
        destinationAddressAdditional: this.fb.group({
          modifier: [preValues.originAddressAdditional.modifier],
          modifierTwo: [preValues.originAddressAdditional.modifierTwo],
          floor: [preValues.originAddressAdditional.floor],
          room: [preValues.originAddressAdditional.room],
          aptOrSuite: [preValues.originAddressAdditional.aptOrSuite],
          place: [preValues.originAddressAdditional.place],
          phone: [preValues.originAddressAdditional.phone]
        }),
        appointmentDirection: ['']

      })
    );
    // }
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    items.removeAt(index);
  }

  get addonsForm() {
    return this.newTripForm.get('addonServices') as FormArray;
  }

  get multidates() {
    return this.newTripForm.get('multidates') as FormArray;
  }

  addAddonsItem(preAddonList?) {
    const items = this.newTripForm.get('addonServices') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            fare: [addon.fare],
            code: [addon.code],
            total: [addon.total]
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        fare: [0],
        code: [0],
        total: [0]
      })
    );
    // }
  }

  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addonServices') as FormArray;
    items.removeAt(index);
  }

  addMultidateEntry(): void {
    if (!this.dateMultiDays || this.multidates.length >= 10) return;

    const dayStart = moment(this.dateMultiDays).tz(this.timeZone).startOf('day');

    const exist = this.multidates.value.some(
      item => item.preDate === dayStart.format('MM/DD/YYYY')
    );
    if (exist) return;

    this.multidates.push(this.fb.group({
      preDate: [dayStart.format('MM/DD/YYYY')],
      date: [dayStart.toISOString()]
    }));

    this.dateMultiDays = null;
  }

  removeMultidate(index: number): void {
    this.multidates.removeAt(index);
  }


  onSelectMember(event) {
    let member;
    if (event) {
      member = this.memberList.find((member) => member._id === event);
      this.selectedMember = member;
    }
    this.resetAvailabilityStats();
    this.setMemberDetails(member);
  }

  setMemberDetails(member) {
    try {
      if (member) {
         this.selectedMember = member;
           const aptOrSuite = member.homeAddress && member.homeAddress.aptOrSuite || '';
        const covidStatus = member.covidStatus || '';

        let combinedNotes: string[] = [];

        if (aptOrSuite) {
          combinedNotes.push(`APT: ${aptOrSuite}`);
        }

        if (covidStatus) {
          combinedNotes.push(`Med Cond: ${covidStatus}`);
        }

        let companyNote = combinedNotes.join(' // ');
        if (companyNote) {
          companyNote += ' (take precaution as per SOPs)';
        }
        let memberPayload;
        memberPayload = {
          priorityClient: member,
          companyNote: companyNote,
          isVipTrip: member.type === "vip" ? true : false,
          originAddressAdditional: {
            phone: member.contactNumber,
            dispatchNoteTwo: member.note + " ----------  " + member.privateNote,
          },
           eligibilityStatus: member.eligibility ? member.eligibility.status : ''
        }

        if (member.homeAddress && member.homeAddress.address) {
          const parsed = parseAddress(member.homeAddress.address);
          memberPayload = {
            ...memberPayload, jobOriginAddress: member.homeAddress.address,
            jobOriginLatitude: member.homeAddress.latitude,
            jobOriginLongitude: member.homeAddress.longitude,
            zipCodeOrg: member.homeAddress.zipCode,
            cityOrg: parsed ? parsed.city : '',
            stateOrg: parsed ? parsed.state : '',
            puStreet: parsed ? parsed.street : ''
          };
        }

        if (member.homeAddress && member.homeAddress.name) {
          memberPayload = {
            ...memberPayload,
            originAddressAdditional: {
              ...memberPayload.originAddressAdditional,
              place: member.homeAddress.name,
              aptOrSuite: aptOrSuite
            }
          };
        }

        if (member.fundingSource) {
          memberPayload = { ...memberPayload, cooperate: member.fundingSource };
        }

        if (member.spaceType) {
          memberPayload = { ...memberPayload, spaceType: member.spaceType };
        }
        if (member.dob) {
          memberPayload = {
            ...memberPayload,
            priorityClient:{
              ...memberPayload.priorityClient,
              preDob:moment(member.dob),
              dob: member.dob
            }

          };
        }

        this.newTripForm.patchValue(memberPayload);

        if (member.los) {
          this.newTripForm.patchValue({
            los: member.los
          });
          this.onSelectLOS(member.los);
        }

      } else {
        this.newTripForm.patchValue({
          priorityClient: {
            displayName: '',
            contactNumber: '',
            cellPhone: '',
            clientId: '',
            email: '',
            dob: '',
            weight: '',
            gender: ''
          },
        });
      }
    } catch (err) {
      (err);
    }
  }

  setOriginAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);

    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        cityOrg: addressDetails.city,
        stateOrg: addressDetails.state,
        puStreet: addressDetails.street,
        serviceArea: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        cityOrg: addressDetails.city,
        stateOrg: addressDetails.state,
        puStreet: addressDetails.street,
        serviceArea: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  onOriginAddressChange(index?: number) {
    const clearedValue = {
      jobOriginLatitude: 0,
      jobOriginLongitude: 0,
      zipCodeOrg: '',
      cityOrg: '',
      stateOrg: '',
      puStreet: '',
    };
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue(clearedValue);
    } else {
      this.newTripForm.patchValue(clearedValue);
    }
  }

  onDestinationAddressChange(index?: number) {
    const clearedValue = {
      jobDestinationLatitude: 0,
      jobDestinationLongitude: 0,
      zipCodeDest: '',
      cityDest: '',
      stateDest: '',
      doStreet: '',
    };
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue(clearedValue);
    } else {
      this.newTripForm.patchValue(clearedValue);
    }
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        cityDest: addressDetails.city,
        stateDest: addressDetails.state,
        doStreet: addressDetails.street,
        serviceAreaDest: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        cityDest: addressDetails.city,
        stateDest: addressDetails.state,
        doStreet: addressDetails.street,
        serviceAreaDest: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  async calculateSuggestedPickupTime() {
    if (!this.isEnableExpectedAppointment) return;
    if (this.tripId && !this.isEditDataLoaded) return; // prevent calculation on edit trip form load
    this.suggestedPickupTime = null;
    this.is1HourException = false;
    const {
      jobOriginAddress,
      jobOriginLatitude,
      jobOriginLongitude,
      jobDestinationAddress,
      jobDestinationLatitude,
      jobDestinationLongitude,
      actualAppointmentTime
    } = this.newTripForm.value;

    // stop if any of the following doesn't have a value
    if (!(jobOriginAddress && jobDestinationAddress && actualAppointmentTime)) return;

    this.isCalculating = true;
    const queryParams = {
      start: [jobOriginLongitude, jobOriginLatitude].toString(),
      end: [jobDestinationLongitude, jobDestinationLatitude].toString(),
    };

    try {
      const minutes = await this.calculateTime(queryParams);
      this.is1HourException = (minutes + 15) > 60 ? true : false;
      const estimatedPickupTime = moment(actualAppointmentTime).tz(this.timeZone).subtract(minutes, 'minutes');
      this.suggestedPickupTime = estimatedPickupTime;

      const newScheduleTime = estimatedPickupTime.subtract(20, 'minutes');

      this.newTripForm.patchValue({
        preScheduleTime: newScheduleTime,
        scheduleTime: newScheduleTime.toISOString(),

        preAppointmentTime: newScheduleTime.clone().add(minutes,'minutes'),
        appointmentTime: newScheduleTime.clone().add(minutes,'minutes').toISOString(),
      });
      this.isCalculating = false;
    } catch (error) {
      this.isCalculating = false;
    }
  }

  async calculateTime(queryParams) {
    const res: any = await this.assignTripService.calculateMiles(queryParams).pipe(takeUntil(componentDestroyed(this))).toPromise();
    let duration = 60;
    if (
      res &&
      res.features &&
      res.features[0] &&
      res.features[0].properties &&
      res.features[0].properties.segments &&
      res.features[0].properties.segments[0] &&
      res.features[0].properties.segments[0].duration
    ) {
      duration = res.features[0].properties.segments[0].duration / 60;
    }

    return duration;
  }

  setPickTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      // if (!this.tripId && !items.at(index).value.isWillCall) {
      //   items.at(index).patchValue({
      //     preAppointmentTime: moment(event).add(1, 'hours')
      //   });
      // }

    } else {
      this.newTripForm.patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      // if (!this.tripId) {
      //   this.newTripForm.patchValue({
      //     preAppointmentTime: moment(event).add(1, 'hours')
      //   });
      // }
    }
  }

  setDropOffTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

    } else {
      this.newTripForm.patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
    }
  }

  toggleExpectedAppointment() {
    this.isEnableExpectedAppointment = !this.isEnableExpectedAppointment;
    if (!this.isEnableExpectedAppointment) {
      this.clearExpectedAppointmentValidation();
    } else {
      this.form.preActualAppointmentTime.setValidators(Validators.required);
      this.form.preActualAppointmentTime.updateValueAndValidity();
    }
  }

  clearExpectedAppointmentValidation() {
    this.form.preActualAppointmentTime.clearValidators();
    this.form.preActualAppointmentTime.patchValue("");
    this.form.preActualAppointmentTime.updateValueAndValidity();
    this.form.actualAppointmentTime.patchValue("");
    this.form.actualAppointmentTime.updateValueAndValidity();
  }

  setActualAppointmentTimeChange(event) {
    this.newTripForm.patchValue({
      actualAppointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
    });
    this.calculateSuggestedPickupTime(); // calling order matters
  }

  setWillCall(event, index) {
    const items = this.newTripForm.get('tripLegs') as FormArray;

    if (event.target.checked) {
      const time = items.at(index)['controls'].preScheduleTime.value;
      time.set('hour', 23)
      time.set('minute', 59)
      items.at(index).patchValue({
          preScheduleTime: time,
          scheduleTime: time.toISOString(),

          preAppointmentTime: time.clone(),
          appointmentTime: time.clone().toISOString()
      })

      items.at(index)['controls'].preScheduleTime.disable();
    } else {
      items.at(index)['controls'].preScheduleTime.enable();
    }

  }

  setWillCallInEdit(event) {
    if (event.target.checked) {
      const schTime = this.newTripForm['controls'].preScheduleTime.value;
      schTime.set('hour', 23)
      schTime.set('minute', 59)
      this.newTripForm['controls'].preScheduleTime.setValue(schTime);
      this.newTripForm['controls'].preScheduleTime.disable();

      const aptTime = this.newTripForm['controls'].preAppointmentTime.value;
      aptTime.set('hour', 23)
      aptTime.set('minute', 59)
      this.newTripForm['controls'].preAppointmentTime.setValue(aptTime);
      this.newTripForm['controls'].preAppointmentTime.disable();
    } else {
      this.newTripForm['controls'].preScheduleTime.enable();
      this.newTripForm['controls'].preAppointmentTime.enable();
    }
  }

  onSelectFundingSource(event) {
    this.resetAvailabilityStats();
    this.newTripForm.patchValue({
      cooperateDetails: {
        displayName: '',
        profileImageURL: ''
      }
    });
    this.memberList = [];

    const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === event);
    if (fundingSource) {
      this.newTripForm.patchValue({
        cooperateDetails: {
          displayName: fundingSource.displayName,
          profileImageURL: fundingSource.profileImageURL
        }
      });
      //Additional Code removed, clearing the array on change of funding source
      this.getAddonsList(fundingSource._id);
      this.getMemberList(fundingSource._id)

    }
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
  }

  onSelectLOS(losId) {
    this.spaceTypeList = [];
    if (!losId) {
      this.newTripForm.patchValue({
        spaceType: ''
      });
      return;
    };

    this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.newTripForm.value.spaceType);
    if (!spaceTypes.length) {
      this.newTripForm.patchValue({
        spaceType: '',
      });
    }
  }
  onSelectSpaceType() {
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
    this.filteredAddonsList = this.addonsList.filter(item => item.spaceType === this.newTripForm.value.spaceType)
  }


  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTipsService.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })
  }

  removeFile() {
    this.newTripForm.patchValue({ attachment: '' });
    this.fileInput.nativeElement.value = '';
  }


  get standingOrderForm() {
    return this.newTripForm.get('recurringDays') as FormArray;
  }

  addStandingDays(preStandingList?) {

    const recurringDaysItems = this.newTripForm.get('recurringDays') as FormArray;
    if (preStandingList) {

      for (let preItem of preStandingList) {
        const index = recurringDaysItems.controls.findIndex(item => item.value.day === preItem.day);
        if (index > -1) {
          recurringDaysItems.at(index).patchValue({
            checked: true,
            driver: preItem.driver ? preItem.driver : 'null'
          });

          recurringDaysItems.at(index)['controls'].driver.enable();
        }
      }
      return;
    }

    for (let dayItem of getstandingOrderDays) {
      recurringDaysItems.push(
        this.fb.group({
          label: [dayItem.label],
          day: [dayItem.day],
          checked: [false],
          driver: [{ value: 'null', disabled: true }],
        })
      );
    }
  }

  onChangeStandingDay(event, form) {
    if (event) {
      form.controls.driver.enable();
    } else {
      form.controls.driver.disable();
    }
  }

  onChangeStandingStatus(event) {
    const isEnabled = JSON.parse(event.target.value);
    if (this.tripId && !isEnabled) {
      sweetAlert('Alert', 'Are you sure you want to inactive standing orders? This action will reset the recurring date to today and remove all the future existing trips.', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            const standingOrderDate = moment().tz(this.timeZone, true).startOf('day');
            if (this.newTripForm.value.recurringEndDate) {
              const previousDate = moment(this.newTripForm.value.recurringEndDate).tz(this.timeZone, true).startOf('day');
              if (previousDate.isAfter(standingOrderDate)) {
                this.newTripForm.patchValue({
                  preRecurringEndDate: standingOrderDate,
                  recurringEndDate: standingOrderDate.toISOString(),
                  isRecurring: isEnabled
                });
              } else {
                this.newTripForm.patchValue({
                  isRecurring: isEnabled
                });
              }
            } else {
              this.newTripForm.patchValue({
                preRecurringEndDate: standingOrderDate,
                recurringEndDate: standingOrderDate.toISOString(),
                isRecurring: isEnabled
              });
            }
          } else {
            this.newTripForm.patchValue({
              isRecurring: true
            });
          }
        });
    } else {
      this.newTripForm.patchValue({
        isRecurring: isEnabled
      });
    }
  }

  setStandingDateChange(event) {
    if (event) {
      this.newTripForm.patchValue({
        recurringEndDate: moment(event).tz(this.timeZone, true).startOf('day').toISOString()
      });
    }
  }

  async confirmAddressUpdate() {
    let isProceed = false;
    const confirm = await sweetAlertWithTwoCheckboxes(
      "Address Validation Alert!",
      `You want to apply address changes to associated trips?`,
      "warning",
      "Proceed",
      "No"
    );
    if (confirm.value) {
      isProceed = true;
      const {isUpdateSameDayLegs, isUpdateFutureLegs} = confirm.value;
      if (isUpdateSameDayLegs) {
        const control = this.newTripForm.get('isUpdateSameDayLegs');
        control.patchValue(isUpdateSameDayLegs);
        control.enable();
      }
      if (isUpdateFutureLegs) {
        const control2 = this.newTripForm.get('isUpdateFutureLegs');
        control2.patchValue(isUpdateFutureLegs);
        control2.enable();
      }
    }
    return isProceed;
  }

  async onCreateTrip() {
    if(this.tripId){
      const rest = await this.inProgressTripCheck();
      if(rest && rest.status === 'inprogress'){
        sweetAlert('Alert', 'Inprogress trip cannot be edited', 'warning', 'Okay')
        return;
      }
    }
    this.submitted = true;
    if (this.newTripForm.invalid) return;

    if (this.user.showAddressValidationAlert && this.tripDetails
      && !(this.tripDetails.status === 'standing' || this.tripDetails.so)
      && this.isAddressesModified()) {
        const isProceed = await this.confirmAddressUpdate();
        if (!isProceed) return;
    }

    let payload = this.newTripForm.value;
    payload = {
      ...payload,
      attendees: this.selectedAssist && this.selectedAssist.length ?  this.selectedAssist :null,
      payorId: payload.payorId ? payload.payorId : null,
    };

    if (payload.tripLegs && payload.tripLegs.length) {
      payload.tripLegs = payload.tripLegs.map((leg: any) => {
        return leg;
      });
    }

    // checking standing orders
    if (payload.isRecurring) {
      let recurringDays = [];
      for (let standingOrderDay of payload.recurringDays) {
        if (standingOrderDay.checked) {
          recurringDays.push({ ...standingOrderDay, driver: standingOrderDay.driver === 'null' ? null : standingOrderDay.driver })
        }
      }

      if (recurringDays.length) {
        payload.recurringDays = recurringDays;
        payload.status = 'standing';
        payload.jobStatus = 'standing';
      }
      if (!payload.milage)
        delete payload.milage
    } else {
      delete payload.recurringDays
      delete payload.status
      delete payload.jobStatus
    }

    if (!payload.originAddressAdditional.modifier) {
      payload.originAddressAdditional.modifier = null
    }

    if (!payload.destinationAddressAdditional.modifier) {
      payload.destinationAddressAdditional.modifier = null
    }

    for (let leg of payload.tripLegs) {
      if (!leg.originAddressAdditional.modifier) {
        leg.originAddressAdditional.modifier = null
      }

      if (!leg.destinationAddressAdditional.modifier) {
        leg.destinationAddressAdditional.modifier = null
      }
    }
    if (this.isEnabledOneHourException) {
      payload.isAnHourException = isOneHourViolation(payload, this.timeZone);
    }

     const canProceed = await this.checkMemberEligibility(payload);
    if (!canProceed) return;
    
    if(!this.isEnableExpectedAppointment){
      payload.actualAppointmentTime = "";
                                                                                     }

    payload.isEnableExpectedAppointment = this.isEnableExpectedAppointment;

    if (!payload.isRecurring) {
      const multiDates = this.newTripForm.value.multidates;
      payload.multidates = multiDates.map(item => item.date);
    } else {
      delete payload.multidates;
    }

    this.assignTripService
      .createNewTripV2(payload, this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.editId) {
            this.onUpdate.emit(data);
          } else {
            this.onCreate.emit(data);
            this.router.navigateByUrl('trips');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });

}
  async checkMemberEligibility(payload: any) {

  const status = payload.eligibilityStatus;

  // ✅ NEW RULE: pending → NO alert, auto proceed
  if (status === 'pending') {
    return true;
  }

  // RULE: ineligible → always alert
  if (status === 'ineligible') {

    const confirm = await sweetAlert(
      "Warning",
      "Member is not eligible for this ride. Do you want to Proceed?",
      "warning",
      "Yes",
      "No"
    );

    return !!confirm.value;
  }

  // RULE: eligible → check date + quota
  if (status === 'eligible') {

    const scheduleDate = moment(payload.scheduleDate).tz(this.timeZone);

    let start = null;
    let end = null;
    let quota = 0;

    if (this.selectedMember && this.selectedMember.eligibility) {
      start = moment(this.selectedMember.eligibility.startDate).tz(this.timeZone);
      end = moment(this.selectedMember.eligibility.endDate).tz(this.timeZone);
      quota = this.selectedMember.eligibility.tripQuota || 0;
    }

    const isInDateRange =
      scheduleDate.isValid() &&
      start &&
      end &&
      start.isValid() &&
      end.isValid() &&
      scheduleDate.isBetween(start, end, 'day', '[]');

    const isFullyEligible =
      isInDateRange && quota > 0;

    // ✔ fully eligible → NO alert
    if (isFullyEligible) {
      return true;
    }

    // ⚠ eligible but invalid → alert
    let message = "";

    if (!isInDateRange && quota <= 0) {
      message = "Member is not eligible due to date and quota restrictions";
    }
    else if (!isInDateRange) {
      message = "Member is not eligible due to date range.";
    }
    else if (quota <= 0) {
      message = "Member is not eligible due to Trip quota.";
    }

    const confirm = await sweetAlert(
      "Warning",
      message,
      "warning",
      "Yes",
      "No"
    );

return !!confirm.value;
  }

  return true;
}

  async inProgressTripCheck() {
    const res: any = await this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .toPromise();
    return res;
  }

  openAddMemberModal() {
    this.addMemberModalObj = true;
  }

  onSaveMember(evt) {
    if (evt) {
      // Update existing member in the list
      const index = this.memberList.findIndex(member => member._id === evt._id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }
      // Update the form with new member details
      this.newTripForm.patchValue({
        client: evt._id,
         originAddressAdditional: {
          aptOrSuite: evt.homeAddress.aptOrSuite
        }

      });
      this.setMemberDetails(evt);
      this.addMemberModalObj = false;
      // Refresh the dropdown by triggering change detection
    }
  }


  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  calculateEstimatedFare() {
    const { jobOriginLatitude, jobOriginLongitude, jobDestinationLatitude, jobDestinationLongitude, scheduleTime, cooperate, spaceType, milage, addonServices } = this.newTripForm.value;

    if (!jobOriginLatitude || !jobOriginLongitude || !jobDestinationLatitude || !jobDestinationLongitude || !scheduleTime || !cooperate || !spaceType) {
      sweetAlert('Alert', 'Please select Pickup, Drop Off address, Space Type, Pickup Time & Funding Source', 'warning', 'Ok')
      return;
    }

    let payload;

    payload = {
      company: this.user._id,
      jobDestinationLatitude: jobDestinationLatitude,
      jobDestinationLongitude: jobDestinationLongitude,
      jobOriginLatitude: jobOriginLatitude,
      jobOriginLongitude: jobOriginLongitude,
      spaceType: spaceType,
      cooperate: cooperate,
      scheduleTime: scheduleTime
    };

    if (milage) {
      payload.milage = milage;
    }

    if (addonServices && addonServices.length) {
      payload = { ...payload, addonServices: addonServices }
    }

    this.assignTripService
      .calculateEstimateFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.newTripForm.patchValue({
            estimateFare: data.totalFare
          })
        }
      });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    this.addressPickerObj = null;
    const items = this.newTripForm.get('tripLegs') as FormArray;
    if (!event) return;

    const parsed = event.address ? parseAddress(event.address) : null;
    const city = parsed ? parsed.city : '';
    const state = parsed ? parsed.state : '';
    const street = parsed ? parsed.street : '';

    // For Pickup Addresss
    if (event.reference.value === '0') {
      this.newTripForm.patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode,
        cityOrg: city,
        stateOrg: state,
        puStreet: street
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    } else if (event.reference.value === '1') {
      this.newTripForm.patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode,
        cityDest: city,
        stateDest: state,
        doStreet: street
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    } else if (event.reference.value === '01') {
      items.at(0).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode,
        cityOrg: city,
        stateOrg: state,
        puStreet: street
      });
    } else if (event.reference.value === '11') {
      items.at(0).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode,
        cityDest: city,
        stateDest: state,
        doStreet: street
      });
    } else if (event.reference.value === '02') {
      items.at(1).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode,
        cityOrg: city,
        stateOrg: state,
        puStreet: street
      });
    } else if (event.reference.value === '12') {
      items.at(1).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode,
        cityDest: city,
        stateDest: state,
        doStreet: street
      });
    }

    if (this.newTripForm.value.jobOriginAddress &&
      this.newTripForm.value.jobOriginLatitude &&
      this.newTripForm.value.jobOriginLongitude &&
      this.newTripForm.value.jobDestinationAddress &&
      this.newTripForm.value.jobDestinationLatitude &&
      this.newTripForm.value.jobDestinationLongitude) {
    }
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  getAssisData(){
    this.assistService.getAssistList()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.assistList = data;
      }
    });
  }

  isAddressesModified(){
    let bln = false;
    if (
      this.tripDetails.jobOriginAddress !== this.newTripForm.value.jobOriginAddress ||
      this.tripDetails.jobDestinationAddress !== this.newTripForm.value.jobDestinationAddress
    ) {
      bln = true;
    }
    return bln;
  }

  getPayorList() {

    const param = {
      status: 'active'
    };

    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  ngOnDestroy(): void {
  }
}
